import { SALARIES_API_ENDPOINT_ROOT } from '#/modules/salaries/utils/constants/salariesApiEndpointRoot';
import { postJson } from '#/utils/http/postJson';

export function salariesValidateCompensationSurvey(
  payload: Record<string, any>, // oxlint-disable-line typescript/no-explicit-any
  test: boolean,
): Promise<{
  responseCode: 200 | 400;
}> {
  return postJson(
    `${SALARIES_API_ENDPOINT_ROOT}/validation${test ? '?test=true' : ''}`,
    payload,
  );
}
